import {createAsyncActionFactory} from '@wix/live-video-commons'
import type {ThunkConfig} from '../types/config'

export const createAsyncAction = createAsyncActionFactory<ThunkConfig>()
